import COPY from '../../utils/copy'
import NewsletterForm from '../forms/newsletter'

export default function Newsletter() {
  return (
    <section className='h-100% w-screen flex flex-col justify-center items-center bg-newsletter bg-cover bg-no-repeat bg-center py-24'>
      <p className='text-white font-black text-3xl sm:text-5xl text-center mb-4 max-sm:px-4 max-xl:px-24'>
        {COPY.NEWSLETTER_HEADER}
      </p>
      <p className='text-white font-medium text-xl sm:text-2xl text-center max-sm:px-4 max-xl:px-36 mb-6'>
        {COPY.NEWSLETTER_SUBHEADER}
      </p>
      <NewsletterForm />
    </section>
  )
}
